import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from './../../assets/logo-inner.png'


const _hoisted_1 = { class: "auth-navbar" }
const _hoisted_2 = { class: "navbar-container" }
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = { class: "navbar-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo-link"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              alt: "Carenuity logo",
              src: _imports_0,
              class: "logo-img",
              height: "50"
            }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "auth-link"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Dashboard", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/devices",
                class: "auth-link"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Devices", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/alarms",
                class: "auth-link"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Alarms", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "auth-link"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "auth-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, "Logout")
            ], 64))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/auth",
              class: "auth-link"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Log In / Sign Up", -1)
              ]))]),
              _: 1
            }))
      ])
    ])
  ]))
}